exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-0ea4f4e2] {\n  margin-bottom: 20px;\n}\n.el-row[data-v-0ea4f4e2]:last-child {\n    margin-bottom: 0;\n}\n.el-row img[data-v-0ea4f4e2] {\n    width: 90%;\n}\n.el-col[data-v-0ea4f4e2] {\n  border-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0ea4f4e2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/merchant/account/billingtotal.vue
// module id = 1214
// module chunks = 0